import * as classnames from "classnames";
import { useEffect, useState } from "react";

import { useFrontendTemplateList } from "@shared/hooks/query";
import { getFrontendChallengeOptions } from "@shared/services/challenge";

import { Modal, Select, Icon, Msg } from "../../../../shared/components";

export interface SwitchFrontendTemplateProps {
  isOpen: boolean;
  selectedFrontendTemplate?: string;
  allowedFrontendTemplates: string[];
  onSwitchFrontendTemplate: (payload: { seriesCode: string }) => void;
  onCancel?: () => void;
}

export const SwitchFrontendTemplate = ({
  isOpen,
  selectedFrontendTemplate,
  allowedFrontendTemplates,
  onSwitchFrontendTemplate,
  onCancel,
}: SwitchFrontendTemplateProps) => {
  const rootStyle = classnames("code-switch-language");

  const { data: frontendTemplates } = useFrontendTemplateList();
  const [frontendTemplate, setFrontendTemplate] = useState(
    selectedFrontendTemplate,
  );

  useEffect(() => {
    if (selectedFrontendTemplate) {
      setFrontendTemplate(selectedFrontendTemplate);
    }
  }, [selectedFrontendTemplate]);

  const options = getFrontendChallengeOptions({
    frontendTemplates,
    allowedTemplateSeriesCodes: allowedFrontendTemplates,
  });

  return (
    <Modal
      className={rootStyle}
      title={<Msg id={"switch-frontend-template.title"} />}
      isOpen={isOpen}
      onClose={onCancel}
      onClickCancel={onCancel}
      onClickOk={() => {
        if (frontendTemplate) {
          onSwitchFrontendTemplate({ seriesCode: frontendTemplate });
        }
      }}
      disableOk={
        !frontendTemplate || frontendTemplate === selectedFrontendTemplate
      }
      okButtonLabel={<Msg id={"button.switchFrontendTemplate"} />}
      okButtonAriaLabel="Switch Frontend Template"
      ariaLabel="Switch Frontend Template"
    >
      <div className="code-switch-language__body">
        <div className="code-switch-language__item">
          <Icon
            type="exclamation-triangle"
            iconClassName="fa-3x"
            size="large"
          />
        </div>
        <div className="code-switch-language__item">
          <p>
            <Msg id={"switch-frontend-template.text1"} />
          </p>
          <p>
            <Msg id={"switch-frontend-template.text2"} />
          </p>
        </div>
      </div>
      <Select
        name="frontendTemplate"
        options={options}
        value={frontendTemplate}
        onChange={(e) => {
          setFrontendTemplate(e.currentTarget.value);
        }}
      />
    </Modal>
  );
};
